import { clinicActionResendInvitation } from 'lib/api/firebase/apis/apis';
import {
  ActionState,
  ActionTagSettings
} from '../../../../../../components/action-tag/action-tag-component';
import { TableRow } from '../user-table-types';
import { APIAuth } from 'lib/api/firebase/apis/api-auth';

export const BASE_ACTIONS: ActionTagSettings<TableRow>[] = [
  {
    name: 'Resend invite',
    shouldShow: p => p.invitePending,
    initialState: () => ActionState.NEUTRAL,
    onClick: p => {
      if (!p.raw.id) {
        throw new Error('ID is undefined. Please try reloading the page');
      }
      return clinicActionResendInvitation({
        invitationId: p.raw.id,
        resendType: 'email'
      });
    }
  },
  {
    name: 'Reset password',
    shouldShow: true,
    initialState: () => ActionState.NEUTRAL,
    onClick(p) {
      return APIAuth.resetPassword({
        uid: p.raw.id
      });
    }
  }
];
